module.exports = __webpack_public_path__ + "media/customizations/blackwoodgroves/logo-df8ece685bdc8657133354ed8a3e2c75.png";